import React from 'react';
import { FacebookIcon, InstagramIcon, PhoneIcon, MapPinIcon, MailIcon } from 'lucide-react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-blue-900 text-white" data-id="element-62">
      <div className="container mx-auto px-4 py-12" data-id="element-63">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-64">
          <div data-id="element-65">
            <div className="flex items-center mb-4" data-id="element-66">
              <Logo width={140} className="mb-2" inverted={true} data-id="element-67" />
            </div>
            <p className="mb-4 text-gray-300" data-id="element-68">
              Adapazarı'nın güvenilir dizel araç servisinde hızlı, kaliteli ve
              uygun fiyatlı bakım ve onarım hizmetleri.
            </p>
            <div className="flex space-x-4" data-id="element-69">
              <a href="https://www.facebook.com/guven.dizel.7" target="_blank" rel="noopener noreferrer" className="text-white hover:text-green-500 transition" data-id="element-70">
                <FacebookIcon className="w-6 h-6" data-id="element-71" />
              </a>
              <a href="https://www.instagram.com/guven.dizel/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-green-500 transition" data-id="element-72">
                <InstagramIcon className="w-6 h-6" data-id="element-73" />
              </a>
            </div>
          </div>
          <div data-id="element-74">
            <h3 className="text-xl font-bold mb-4" data-id="element-75">Hizmetlerimiz</h3>
            <ul className="space-y-2 text-gray-300" data-id="element-76">
              <li data-id="element-77">
                <a href="#" className="hover:text-green-500 transition" data-id="element-78">
                  Dizel Motor Bakımı
                </a>
              </li>
              <li data-id="element-79">
                <a href="#" className="hover:text-green-500 transition" data-id="element-80">
                  Enjektör Temizliği
                </a>
              </li>
              <li data-id="element-81">
                <a href="#" className="hover:text-green-500 transition" data-id="element-82">
                  Arıza Teşhisi
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-83">
            <h3 className="text-xl font-bold mb-4" data-id="element-84">Hızlı Bağlantılar</h3>
            <ul className="space-y-2 text-gray-300" data-id="element-85">
              <li data-id="element-86">
                <a href="#anasayfa" className="hover:text-green-500 transition" data-id="element-87">
                  Anasayfa
                </a>
              </li>
              <li data-id="element-88">
                <a href="#hizmetler" className="hover:text-green-500 transition" data-id="element-89">
                  Hizmetlerimiz
                </a>
              </li>
              <li data-id="element-90">
                <a href="#hakkimizda" className="hover:text-green-500 transition" data-id="element-91">
                  Neden Biz?
                </a>
              </li>
              <li data-id="element-92">
                <a href="#iletisim" className="hover:text-green-500 transition" data-id="element-93">
                  İletişim
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-94">
            <h3 className="text-xl font-bold mb-4" data-id="element-95">İletişim</h3>
            <ul className="space-y-3 text-gray-300" data-id="element-96">
              <li className="flex items-start" data-id="element-97">
                <MapPinIcon className="w-5 h-5 mr-3 mt-1" data-id="element-98" />
                <span data-id="element-99">
                  Tuzla, 1270. Sk. No:35, 54100 Adapazarı/Sakarya, Türkiye
                </span>
              </li>
              <li className="flex items-center" data-id="element-100">
                <PhoneIcon className="w-4 h-4 mr-3" data-id="element-101" />
                <span data-id="element-102">+90 264 278 08 92</span>
              </li>
              <li className="flex items-center" data-id="element-103">
                <MailIcon className="w-4 h-4 mr-3" data-id="element-104" />
                <span data-id="element-105">tahausta@guvendizel.com</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-10 pt-6 text-center text-gray-400" data-id="element-106">
          <p data-id="element-107">
            &copy; {new Date().getFullYear()} Güven Dizel. Tüm hakları saklıdır.
          </p>
        </div>
      </div>
    </footer>;
}